var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLargeCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.488 22.394h8.353v19.42H8.488zm28.062 0h8.355v19.42H36.55z",
    fill: "#DEE1EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.84 14.8h19.71v27.013H16.84z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.173 42.141H8.16V22.065h9.013zm-8.353-.656h7.696V22.722h-7.7zm36.413.656h-9.01V22.065h9.01zm-8.354-.656h7.698V22.722h-7.698z",
    fill: "#5E6175"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.938 24.474v3.758H33.36v-3.758zm0 6.622v3.758H33.36v-3.758z",
    fill: "#A9AFC4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.688 35.182H19.61v-4.414h14.08zm-13.425-.656h12.769v-3.102H20.266zM7.176 20.742h9.666v1.652H7.176zm8.168-7.594h22.602v1.651H15.344zm21.206 7.594h9.882v1.652H36.55z",
    fill: "#5E6175"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M44.908 35.013v6.8H36.28a8.885 8.885 0 0 1 8.627-6.8",
    fill: "url(#paint0_linear_9129_33537)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.145 26.615h2.903v3.758h-2.903zm28.132 0h2.904v3.758h-2.904z",
    fill: "#A9AFC4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.377 30.702h-3.56v-4.415h3.56zm-2.904-.657h2.247v-3.102h-2.247zm31.037.657h-3.56v-4.415h3.56zm-2.904-.657h2.247v-3.102h-2.248zm-5.918-1.485H19.61v-4.414h14.08zm-13.425-.656h12.769v-3.102H20.266z",
    fill: "#5E6175"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.953 38.016h3.271v3.797h-3.27z",
    fill: "#2C9424"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.756 14.63a1.05 1.05 0 1 1 .003-2.102 1.05 1.05 0 0 1-.003 2.101m5.932-4.151a1.446 1.446 0 1 1 0-2.893 1.446 1.446 0 0 1 0 2.893m0-2.235",
    fill: "#5E6175"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.05 14.351a2.324 2.324 0 0 1 2.325 2.325 2.325 2.325 0 0 1 2.325-2.325 2.325 2.325 0 0 1-2.325-2.32 2.324 2.324 0 0 1-2.324 2.32M47.973 19a1.117 1.117 0 0 1 1.116 1.117A1.116 1.116 0 0 1 50.204 19a1.115 1.115 0 0 1-1.118-1.116A1.117 1.117 0 0 1 47.973 19",
    fill: "#2C9424"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m5.516 44.036 1.517-1.517.464.464L5.98 44.5zm3.191-.152h.656v2.146h-.656zm-4.769-3.093h2.145v.656H3.938zM28.57 24.474h.657v3.758h-.657zm-4.382 0h.656v3.758h-.657z",
    fill: "#5E6175"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.938 17.928v3.758H33.36v-3.758z",
    fill: "#A9AFC4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.688 22.014H19.61V17.6h14.08zm-13.425-.656h12.769v-3.102H20.266z",
    fill: "#5E6175"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.57 17.928h.657v3.758h-.657zm-4.382 0h.656v3.758h-.657z",
    fill: "#5E6175"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.904 51.04a7.157 7.157 0 1 0 0-14.314 7.157 7.157 0 0 0 0 14.315",
    fill: "#F5F5F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.904 51.369a7.486 7.486 0 1 1 7.485-7.486 7.495 7.495 0 0 1-7.485 7.486m0-14.315a6.829 6.829 0 1 0 6.829 6.83 6.837 6.837 0 0 0-6.83-6.83",
    fill: "#5E6175"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.28 48.085h-.657v-.656h.656zm-1.75 0h-.657v-.656h.656zm-1.75 0h-.657v-.656h.656zm-1.75 0h-.657v-.656h.656zm-1.75 0h-.657v-.656h.656zm-1.871-.255a2.1 2.1 0 0 1-.6-.49l.502-.422q.175.206.412.336zm-1.082-1.674c-.009-.11-.006-.142-.006-.681h.656v.632zm.65-1.775h-.656v-.656h.656z",
    fill: "#A9AFC4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.88 42.14H16.516V14.47H36.88zm-19.711-.656h19.055V15.125H17.172z",
    fill: "#5E6175"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.776 4.959H23.62a1.21 1.21 0 0 0-1.21 1.21v6.197c0 .669.541 1.21 1.21 1.21h6.155a1.21 1.21 0 0 0 1.21-1.21V6.17a1.21 1.21 0 0 0-1.21-1.211",
    fill: "#F5F5F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.774 13.905h-6.15a1.54 1.54 0 0 1-1.538-1.54V6.17a1.54 1.54 0 0 1 1.539-1.54h6.153a1.54 1.54 0 0 1 1.54 1.54v6.196a1.54 1.54 0 0 1-1.544 1.539m-6.15-8.618a.884.884 0 0 0-.882.883v6.196a.884.884 0 0 0 .883.883h6.153a.884.884 0 0 0 .883-.883V6.17a.884.884 0 0 0-.883-.883z",
    fill: "#5E6175"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.697 11.465a1.303 1.303 0 0 1-1.302-1.303h.816a.487.487 0 1 0 .486-.485A1.302 1.302 0 1 1 28 8.374h-.816a.486.486 0 1 0-.487.486 1.303 1.303 0 1 1 0 2.605",
    fill: "#2C9424"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.29 6.664h.815v.814h-.816zm0 4.393h.815v.813h-.816zm19.774 31.307H43.75l-1.337 1.615a2.42 2.42 0 0 0 1.859 3.963h1.265a2.42 2.42 0 0 0 1.86-3.963zm-2.284-.646-.749-1.894h1.163a.79.79 0 0 1 .792.792v.43a.79.79 0 0 1 .79-.792h.766l-.578 1.464z",
    fill: "#2C9424"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.082 31.096h.656v3.758h-.656zm4.488 0h.657v3.758h-.657z",
    fill: "#5E6175"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9129_33537",
    x1: 36.281,
    y1: 38.412,
    x2: 44.908,
    y2: 38.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeCompany);
export default __webpack_public_path__ + "static/media/large-company.88ef3979fad0e00b62d679dcc620273a.svg";
export { ForwardRef as ReactComponent };